export default function Back(props) {
    return (
        <>
            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.51444 1.109C7.83808 0.484661 6.78365 0.526832 6.1593 1.2032L0.774684 7.03646C0.185354 7.6749 0.185348 8.65896 0.774671 9.2974L6.15929 15.1308C6.78363 15.8072 7.83806 15.8494 8.51443 15.225C9.1908 14.6007 9.23298 13.5462 8.60865 12.8699L5.80597 9.83361L21.9994 9.83361C22.9198 9.8336 23.666 9.08741 23.666 8.16694C23.666 7.24646 22.9198 6.50027 21.9993 6.50027L5.80602 6.50027L8.60863 3.46414C9.23298 2.78778 9.19081 1.73335 8.51444 1.109Z" fill="#23262F" />
            </svg>
        </>
    )
}


